import { useWorkspaceAccount } from '../WorkspaceAccountProvider'

type Props = {
  /** Show even when only one mode exists (disabled sibling). */
  alwaysShow?: boolean
}

/** LIVE / DEMO account switcher for Account Center & History. */
export function AccountSwitcher({ alwaysShow = false }: Props) {
  const ws = useWorkspaceAccount()
  const live = ws.accounts.find((a) => {
    const m = String(a.mode || '').toUpperCase()
    return m === 'LIVE' || m === 'REAL'
  })
  const demo = ws.accounts.find((a) => String(a.mode || '').toUpperCase() === 'DEMO')

  if (!live && !demo) return null
  if (!alwaysShow && (!live || !demo)) return null

  const current = String(ws.mode || '').toUpperCase()
  const isLive = current === 'LIVE' || current === 'REAL'

  return (
    <div className="cp-account-switcher" role="group" aria-label="Account mode">
      <button
        type="button"
        className={isLive ? 'is-active' : ''}
        onClick={() => live && ws.setAccountId(live.id)}
        disabled={!live || ws.refreshing}
        title={!live ? 'No Live account yet' : undefined}
      >
        LIVE
      </button>
      <button
        type="button"
        className={!isLive && demo ? 'is-active' : ''}
        onClick={() => demo && ws.setAccountId(demo.id)}
        disabled={!demo || ws.refreshing}
        title={!demo ? 'No Demo account yet' : undefined}
      >
        DEMO
      </button>
    </div>
  )
}
